import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_SESSION_TICKETS,
  GET_SESSION_TICKET_DETAIL,
  ADD_NEW_SESSION_TICKET,
  UPDATE_SESSION_TICKET,
  DELETE_SESSION_TICKET,
  GET_EXPORT_SESSION_TICKETS,
  MANUAL_LIFTUP_BARRIER_REQ,
} from "./actionTypes"
import {
  getSessionTicketSuccess,
  getSessionTicketsFail,
  getSessionTicketDetailSuccess,
  getSessionTicketDetailFail,
  addSessionTicketFail,
  addSessionTicketSuccess,
  updateSessionTicketSuccess,
  updateSessionTicketFail,
  deleteSessionTicketSuccess,
  deleteSessionTicketFail,
  getExportSessionTicketsSuccess,
  getExportSessionTicketsFail,
  postManualLiftupBarrierSuccess,
  postManualLiftupBarrierFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getSessionTickets,
  getSessionTicketDetails,
  addNewSessionTicket,
  updateSessionTicket,
  deleteSessionTicket,
  getExportSessionTickets,
  postLiftUpBarrier,
} from "helpers/backend_helper"

function* fetchSessionTickets({ payload }) {
  try {
    const response = yield call(getSessionTickets, payload)
    yield put(getSessionTicketSuccess(response))
  } catch (error) {
    yield put(getSessionTicketsFail(error))
  }
}

function* fetchSessionTicketDetail({ SessionTicketId }) {
  try {
    const response = yield call(getSessionTicketDetails, SessionTicketId)
    yield put(getSessionTicketDetailSuccess(response))
  } catch (error) {
    yield put(getSessionTicketDetailFail(error))
  }
}

function* onUpdateSessionTicket({ payload: SessionTicket }) {
  try {
    const response = yield call(updateSessionTicket, SessionTicket)
    if (response?.success) {
      yield put(updateSessionTicketSuccess(response))
    } else {
      yield put(updateSessionTicketFail(response))
    }
  } catch (error) {
    yield put(updateSessionTicketFail(error))
  }
}

function* onAddNewSessionTicket({ payload: SessionTicket }) {
  try {
    const response = yield call(addNewSessionTicket, SessionTicket)
    if (response?.success) {
      yield put(addSessionTicketSuccess(response))
    } else {
      yield put(addSessionTicketFail(response))
    }
  } catch (error) {
    yield put(addSessionTicketFail(error))
  }
}

function* onDeleteSessionTicket({ payload: SessionTicket }) {
  try {
    const response = yield call(deleteSessionTicket, SessionTicket)
    if (response?.success) {
      yield put(deleteSessionTicketSuccess(SessionTicket))
    } else {
      yield put(deleteSessionTicketFail(response))
    }
  } catch (error) {
    yield put(deleteSessionTicketFail(error))
  }
}

function* fetchExportSessionTickets({ payload }) {
  try {
    const response = yield call(getExportSessionTickets, payload)
    yield put(getExportSessionTicketsSuccess(response))
  } catch (error) {
    yield put(getExportSessionTicketsFail(error))
  }
}

function* onPostLiftUpBarrierRequest({ payload }) {
  try {
    const response = yield call(postLiftUpBarrier, payload)
    if (response?.success) {
      yield put(postManualLiftupBarrierSuccess(payload))
    } else {
      yield put(postManualLiftupBarrierFail(response))
    }
  } catch (error) {
    yield put(postManualLiftupBarrierFail(error))
  }
}

function* sessionTicketSaga() {
  yield takeEvery(GET_SESSION_TICKETS, fetchSessionTickets)
  yield takeEvery(GET_SESSION_TICKET_DETAIL, fetchSessionTicketDetail)
  yield takeEvery(ADD_NEW_SESSION_TICKET, onAddNewSessionTicket)
  yield takeEvery(UPDATE_SESSION_TICKET, onUpdateSessionTicket)
  yield takeEvery(DELETE_SESSION_TICKET, onDeleteSessionTicket)
  yield takeEvery(GET_EXPORT_SESSION_TICKETS, fetchExportSessionTickets)
  yield takeEvery(MANUAL_LIFTUP_BARRIER_REQ, onPostLiftUpBarrierRequest)
}

export default sessionTicketSaga
